import store from '../store'

const shopLocalStorage = () => {
  const getShopId = () => store.getters['shopStore/GET_SHOPID']
  const getUserId = () => localStorage.getItem('userId')

  return {
    getShopId,
    getUserId
  }
}

export default { shopLocalStorage }



// WEBPACK FOOTER //
// ./src/apis/global-storage.js